import { inMainMenu } from '@/extensions/types'
import type { ExtensionView } from '@/extensions/types'

/**
 * A tenant's own main menu (tenant settings `theme.menu`, signed in only): the view ids to show,
 * in their order, all at the top level. Tenants that share an extension can show different parts
 * of it, e.g. a sales demo only the views it is shown with. The extension's groups are left out,
 * the user-menu and floating views stay as they are, and the views the list leaves out are not routed: their
 * addresses open the landing page. Unknown ids are ignored; without the setting, or when it names
 * none of the extension's views, the extension's own menu.
 */
export function tenantMenu(views: ExtensionView[], menu: unknown): { views: ExtensionView[]; hidden: ExtensionView[]; flat: boolean } {
    if (!Array.isArray(menu)) return { views, hidden: [], flat: false }
    const main = views.filter(inMainMenu)
    const chosen = [...new Set(menu)].map((id) => main.find((view) => view.id === id)).filter((view): view is ExtensionView => view !== undefined)
    if (chosen.length === 0) return { views, hidden: [], flat: false }
    return {
        views: [...chosen, ...views.filter((view) => !inMainMenu(view))],
        hidden: main.filter((view) => !chosen.includes(view)),
        flat: true,
    }
}
